import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import {selectManageOrganization, selectApp} from 'store/selectors';

import {Organization} from 'api/types/organisationTypes';
import {Dropdown, ListHeader, Loading} from 'components';

import {
  loadUsers,
  downloadResult,
  CHOOSE_ORGANIZATION_ALL,
} from './redux/thunks';
import {useData, useModal} from './hooks';
import {findUserType, USER_TYPE} from './userType';

import AddUserModal from './AddUserModal';
import UserList from './UserList';
import i18n from 'i18next';
import {loadOrganizationsThunk} from 'containers/ManageOrganizationPage/redux/thunks';
import i18next from 'i18next';

export default function UserPage(): JSX.Element {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [selectedOrganization, setSelectedOrganization] =
    useState<Organization>();

  const dispatch = useDispatch();
  const {user: {role: authType = ''} = {}} = useSelector(selectApp);
  const {data: organizations} = useSelector(selectManageOrganization);
  const {data, userType, loading} = useData();
  const {showModal, selectedUser, onShowModal, onClick} = useModal(data);

  const {type} = useParams<{type?: string}>();
  const selectedRole = findUserType(type);

  useEffect(() => {
    dispatch(loadOrganizationsThunk());
  }, [dispatch]);

  useEffect(() => {
    if (type && type !== userType) {
      dispatch(loadUsers(type, CHOOSE_ORGANIZATION_ALL));
    }
  }, [dispatch, userType, type]);

  useEffect(() => {
    if (organizations && organizations.length === 1) {
      setSelectedOrganization(organizations[0]);
    }
  }, [dispatch, organizations]);

  const onDownload = () => {
    dispatch(downloadResult(userType));
  };

  const handleShowDropdown = () => setShowDropdown(!showDropdown);

  const onClickDropdown = () => {
    handleShowDropdown();
  };

  const onSelectOrganization = (select: string) => () => {
    const selected =
      organizations && organizations.find(({id}) => id === select);

    setSelectedOrganization(selected);

    if (type && selected?.id) {
      dispatch(loadUsers(type, selected.id));
    } else if (type && select === CHOOSE_ORGANIZATION_ALL) {
      dispatch(loadUsers(type, CHOOSE_ORGANIZATION_ALL));
    }

    handleShowDropdown();
  };

  const isSuperAdmin = authType === USER_TYPE.SUPER_ADMIN.serverAlias;

  // omg
  const maxCount =
    (selectedRole.id === USER_TYPE.CONTENT_CREATOR.id
      ? selectedOrganization?.maxContentCreators
      : selectedRole.id === USER_TYPE.LEARNER.id
      ? selectedOrganization?.maxLearners
      : 0) || 0;

  const currentCount = data?.length || 0;

  const showNumberOfUsers =
    selectedOrganization && selectedRole.id !== USER_TYPE.ADMIN.id;

  console.log('Organization', selectedOrganization);

  return (
    <>
      <ListHeader
        header={selectedRole.text}
        subtitle={
          showNumberOfUsers
            ? i18next.t('common.currentVsMaximum', {
                current: currentCount,
                max: maxCount,
              })
            : ''
        }
        onDownload={userType !== USER_TYPE.ADMIN.id ? onDownload : undefined}
        onAdd={
          !isSuperAdmin || !!selectedOrganization?.id ? onClick() : undefined
        }
      />
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="w-7/12 m-auto">
            <div className="flex items-center justify-between py-2">
              {isSuperAdmin && (
                <Dropdown
                  active={showDropdown}
                  onClick={onClickDropdown}
                  onSelect={onSelectOrganization}
                  selected={selectedOrganization?.id}
                  label={i18n.t('manageUserPage.ogranisationDropdownLabel')}
                  placeholder={i18n.t(
                    'manageUserPage.ogranisationDropdownPlaceholder'
                  )}
                  placeholderId={CHOOSE_ORGANIZATION_ALL}
                  className="w-5/12"
                >
                  {organizations &&
                    organizations.map(({id, name}) => (
                      <span key={id} id={id}>
                        {name}
                      </span>
                    ))}
                </Dropdown>
              )}
            </div>
          </div>
          <UserList
            data={data}
            onClick={onClick}
            className={isSuperAdmin ? 'h-full-48' : 'h-full-24'}
            showOrganization={isSuperAdmin && !selectedOrganization?.id}
          />
          <AddUserModal
            show={showModal}
            userType={selectedRole.id}
            onClose={onShowModal}
            organizationId={isSuperAdmin ? selectedOrganization?.id || '' : ''}
            disabled={isSuperAdmin && !selectedOrganization?.id}
            maxReached={maxCount > 0 && currentCount >= maxCount}
            selectedUser={selectedUser}
          />
        </>
      )}
    </>
  );
}
